import { HttpErrorResponse } from '@angular/common/http';

export class MockTest {

  static criarMockAtributoRequest(): any {
    const mockAtributoRequest = {
      "documentid": "01",
      "name": "name"
    }
    return mockAtributoRequest;
  }

  static criarMockProtocolo(): any {
    const mockProtocolo = {
      "numeroProtocolo": "123456789",
    }
    return mockProtocolo;
  }

  static criarMockAccountDataAnalitico(): any {
    const data = {
      "userData": "123456789",
      "documentoCliente": "1234",
      "fullName":"Nome Testando Testado"
    }
    return data;
  }

  static criarMockMotivoDropdown(): any {
    const mockProtocolo = {
        "value": "item1",
        "options": ["item1", "item2"],
    }
    return mockProtocolo;
  }

  static criarMockPedido(protocolo: string, status: string): any {
    const mockPedido = {
      "orders": [
        {
          "orderId": "5ed14e04df54370001f7d890",
          "document": "01506420168",
          "protocol": protocolo,
          "status": status,
          "dtCreate": "2020-05-29 15:01:40",
          "dtUpdate": null,
          "dtExpiration": "2020-06-13 15:01:40",
          "purposes": [
            {
              "description": "MARKETING",
              "tableAttributes": [
                "documento de identidade",
                "status da receita federal",
                "data de nascimento"
              ],
              "reason": {
                "id": "1",
                "description": "Marketing direto por telefone (telemarketing) "
              }
            }
          ]
        }
      ]
    }

    return mockPedido;
  }

  static criarMockFinalidadeRequest(finalidade: string, name: string): any {

    const mockFinalidade = {
      "id": 1,
      "description": name,
      "columnAttributes": [
        {
          "id": 1,
          "alias": "Nome",
          "name": "nome"
        },
        {
          "id": 2,
          "alias": "Segundo atributo",
          "name": "segundoAtributo"
        },
        {
          "id": 3,
          "alias": "Terceiro atributo",
          "name": "terceiroAtributo"
        },
      ],
      "reasons": [
        "Marketing direto por telefone (telemarketing)",
        "Motivo 2",
        "Motivo 3"
      ]
    };

    return mockFinalidade;
  }

  static  criarMockListaFinalidadeRequest(): any {
    const mockListaFinalidade = [
      MockTest.criarMockFinalidadeRequest("FINALIDADE 01", "MARKETING"),
      MockTest.criarMockFinalidadeRequest("FINALIDADE 02", "CREDITO"),
      MockTest.criarMockFinalidadeRequest("FINALIDADE 03", "FRAUDE"),
      MockTest.criarMockFinalidadeRequest("FINALIDADE 04", "DATA QUALITY"),
      MockTest.criarMockFinalidadeRequest("FINALIDADE 06", "CERTIFICADO_DIGITAL"),
    ]

    return mockListaFinalidade;
  }

  static criarMockEndereco(): any {
    return '{"endereco":"R CANDIDO DE ARRUDA BOTELH 001220","bairro":"PRQ STA FELICIA JARDIM","municipio":"SAO CARLOS","uf":"SP","cep":"13563300"}';
  }

  static criarMockconsultarInformacoesRelatorio(): any {
    let mockRetorno =
    {
      "idOrder": "5ede7ae375eb6c0001850b7c",
      "document": "01506420168",
      "protocol": "15910105691552",
      "dtCreate": [
        2020,
        6,
        8,
        10,
        15,
        30,
        234000000
      ],
      "dtUpdate": [
        2020,
        6,
        8,
        10,
        15,
        35,
        234000000
      ],
      "dtExpiration": [
        2020,
        6,
        8,
        10,
        18,
        32,
        234000000
      ],
      "blocks": [
        {
          "description": "Dados Cadastrais",
          "attributes": [
            {
              "description": "Nome",
              "alias": "Nome Civil",
              "value": "Pedro de Araújo Monteiro",
              "origin": "BRADESCO",
              "tableName": "positivo:ds_hist_dados_cadastrais",
              "createDate": null,
              "purposes": [
                "MARKETING"
              ]
            },
            {
              "description": "outrosDocumentos",
              "alias": "Documento de identidade",
              "value": "{\"documento\":\"533820534\",\"orgaoExpedidor\":\"PPR 0\",\"ufExpedicao\":null,\"dataExpedicao\":null}",
              "origin": "bla bla bla",
              "tableName": "BIPESSFI",
              "createDate": "2020-08-28",
              "purposes": [
                "MARKETING",
                "CREDITO",
                "DATA_QUALITY",
                "FRAUDE",
                "CERTIFICADO_DIGITAL",
              ],
              "disclaimer": false
            },
            {
              "description": "CPF",
              "alias": "CPF",
              "value": "321.123.654-90",
              "origin": "Caixa Economica Federal",
              "tableName": "positivo:ds_hist_dados_cadastrais",
              "createDate": null,
              "purposes": [
                "CREDITO"
              ]
            },
            {
              "description": "CPF",
              "alias": "CPF",
              "value": "321.123.654-90",
              "origin": "",
              "tableName": "positivo:ds_hist_dados_cadastrais",
              "createDate": null,
              "purposes": [
                "MARKETING"
              ]
            },
            {
              "description": "nomemae",
              "alias": "Nome da mãe",
              "value": "Geraldo Magela Monteiro",
              "origin": "Caixa Economica Federal",
              "tableName": "positivo:ds_hist_dados_cadastrais",
              "createDate": null,
              "purposes": [
                "CREDITO"
              ]
            },
            {
              "description": "birthdate",
              "alias": "Nome de nascimento",
              "value": "19730809",
              "origin": "Caixa Economica Federal",
              "tableName": "positivo:ds_hist_dados_cadastrais",
              "createDate": null,
              "purposes": [
                "CREDITO"
              ]
            }
          ]
        },
        {
          "description": "Dados de Localização",
          "attributes": [
            {
              "description": "endereco",
              "alias": "Logradouro",
              "value": "{'NULOGCAD':'1220','DECOMPLCAD':'','COCEPCAD':'13563300','NOBAIRROCAD':'Parque Santa Felicia Jardim','COUFCAD':'SP','DEENDCAD':'Rua Candido De Arruda Botelho','NOMUNCAD':'Sao Carlos'}",
              "origin": "BRADESCO",
              "tableName": "positivo:ds_hist_dados_cadastrais",
              "createDate": null,
              "purposes": [
                "MARKETING"
              ]
            },
            {
              "description": "endereco",
              "alias": "Logradouro",
              "value": "Av. Paulista",
              "origin": "BRADESCO",
              "tableName": "positivo:ds_hist_dados_cadastrais",
              "createDate": null,
              "purposes": [
                "CREDITO"
              ]
            }
          ]
        },
        {
          "description": "Participação Societária",
          "attributes": [
            {
              "description": "partiSocietaria",
              "alias": "% de participação",
              "value": "50%",
              "origin": "ITAU",
              "tableName": "positivo:ds_hist_dados_cadastrais",
              "createDate": null,
              "purposes": [
                "CREDITO"
              ]
            },
            {
              "description": "empresa",
              "alias": "Empresa",
              "value": "Zig Desenvolvimento de Software LTDA",
              "origin": "BRADESCO",
              "tableName": "positivo:ds_hist_dados_cadastrais",
              "createDate": null,
              "purposes": [
                "CREDITO"
              ]
            }
          ]
        },
        {
          "description": "DADOS DE CONSULTA DE CRÉDITO AO CPF",
          "attributes": [
            {
              "description": "partiSocietaria",
              "alias": "% de participação",
              "value": "50%",
              "origin": "ITAU",
              "tableName": "positivo:ds_hist_dados_cadastrais",
              "createDate": null,
              "purposes": [
                "CREDITO"
              ]
            },
            {
              "description": "empresa",
              "alias": "Empresa",
              "value": "Zig Desenvolvimento de Software LTDA",
              "origin": "BRADESCO",
              "tableName": "positivo:ds_hist_dados_cadastrais",
              "createDate": null,
              "purposes": [
                "CREDITO"
              ]
            }
          ]
        },
        {
          "description": "OUTROS DADOS CADASTRAIS",
          "attributes": [
            {
              "description": "partiSocietaria",
              "alias": "% de participação",
              "value": "50%",
              "origin": "ITAU",
              "tableName": "positivo:ds_hist_dados_cadastrais",
              "createDate": null,
              "purposes": [
                "CREDITO"
              ]
            },
            {
              "description": "empresa",
              "alias": "Empresa",
              "value": "Zig Desenvolvimento de Software LTDA",
              "origin": "BRADESCO",
              "tableName": "positivo:ds_hist_dados_cadastrais",
              "createDate": null,
              "purposes": [
                "CREDITO"
              ]
            },
            {
              "description": "empresa",
              "alias": "Empresa",
              "value": "Zig Desenvolvimento de Software LTDA",
              "origin": "BRADESCO",
              "tableName": "positivo:ds_hist_dados_cadastrais",
              "createDate": null,
              "purposes": [
                "MARKETING"
              ]
            }
          ]
        },
        {
          "description": "Consultas ao CPF",
          "attributes": [],
          "passages": [
            {
              "cnpj": "17.192.451/0001-70",
              "dtSearch": "2017-04-09",
              "numSearches": "1",
              "origin": "SERASA",
              "purposes": [
                "CREDITO"
              ],
              "empresa": "ROSA MARIA LOPES DA SILVA"
            }
          ],
        },
        {
          "description": "Consultas à Serasa - Lock&Unlock",
          "attributes": [],
          "passages": [
            {
              "cnpj": "61.074.175/0001-38",
              "dtSearch": "2021-05-24",
              "numSearches": "1",
              "origin": "SERASA",
              "purposes": [
                "CREDITO"
              ],
              "empresa": "UKYCIW GWFMLOE NHTKKE M.C."
            }
          ],
        },
        {
          "description": "Dados de Participação societária",
          "attributes": [],
          "passages": [],
          "partnerParticipations": [
            {
              "business": "T2",
              "cnpj": "005375166",
              "situation": "ATIVA",
              "porcParticipation": "45,0",
              "since": "2002-10-01",
              "dtUpdated": "2002-10-01",
              "origin": "RECEITA FEDERAL",
              "purposes": [
                "CREDITO"
              ],
              "disclaimer": false
            }
          ]
        },
      ]
    }

    return mockRetorno;
  }

  /**
   *
   * @param codigoErro - codigo do erro http ex: 404, 500, 401 ...
   */
  static criarMockErroHttp(codigoErro: string): any {
    let mockErroHttp: HttpErrorResponse | any;

    switch (codigoErro) {
      case '404':
        mockErroHttp = new HttpErrorResponse({ error: this.erro404(), status: 404 });
        break;
      case '404.3':
        mockErroHttp = new HttpErrorResponse({ error: this.erro404_3(), status: 404 });
        break;
      case '500':
        mockErroHttp = new HttpErrorResponse({ error: this.erro500(), status: 500 });
        break;

    }
    return mockErroHttp;
  }

  static criarMockExportPdf(): any {
    return new Blob(["text pdf"], { type: 'text/plain' });
  }

  // Mock Retorno de erros http
  private static erro404(): any {
    let mockErro404 = [
      {
        "code": "404",
        "message": "404 NOT FOUND"
      }
    ];
    return mockErro404;
  }

  private static erro404_3(): any {
    let mockErro404 = [
      {
        "code": "404.3",
        "message": "PEDIDO NÃO ENCONTRADO"
      }
    ];
    return mockErro404;
  }

  private static erro500(): any {
    let mockErro404 = [
      {
        "code": "500.9",
        "message": "Erro interno"
      }
    ];
    return mockErro404;
  }

  static CriarMockaccountData() {
    let dados = {
      "id": "5e7cbeb79e2eea162b32ac4c",
      "fullName": "ERFAWR CXCIHWWZT TXFTRSVHJ",
      "document": {
        "documentId": "00000699900",
        "documentCountry": "BRA"
      },
      "birthDate": "1974-06-29",
      "email": {
        "email": "00000699900@br.experian.com"
      },
      "mobile": {
        "regionCode": 55,
        "areaCode": 11,
        "phoneNumber": 900699900
      },
      "userEcs": {
        "hercules": {
          "fraudnet": "Aprovado",
          "crossCore": true,
          "mobileTruste": true
        },
        "picture": "https://www.serasaconsumidor.com.br/navbar-avatar.png"
      }
    }
    return dados
  }

}
